import Button, { ButtonProps } from '@material-ui/core/Button';
import React from 'react';

const CustomButton: React.FC<ButtonProps> = (props) => (
  <Button size="large" variant="outlined" {...props}>
    {props?.children}
  </Button>
);

export default CustomButton;
